import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetActiveEventsCall} from '../../apis/event';
import {SET_ACTIVE_EVENTS} from '../../constants/MonitorConstants';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';

function* tryFunction() {
    const response: number[] = yield call(GetActiveEventsCall);
    yield put({type: SET_ACTIVE_EVENTS, payload: response});
}

export function* getActiveEventsSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GENERIC_ERROR,
    };
    yield call(skeletonSaga, sagaPayload);
}
